import React from 'react'
import MainLayout from './hoc/MainLayout/MainLayout.js'
import SipCallRender from './containers/SipCallRender/SipCallRender'

function App() {
  return (
      <MainLayout>
          <SipCallRender/>
      </MainLayout>
  );
}
export default App;
